module.exports = __webpack_public_path__ + "static/media/sheepMale.d28fbf44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sheepMale.svg
// module id = 378
// module chunks = 0